(function () {
  'use strict';
  angular
    .module('frontendApp',
      [
        'ui.bootstrap',
        'ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ngResource',
        'ui.router',
        'toastr',
        'LocalStorageModule',
        'satellizer',
        'sap.imageloader',
        'angular-inview',
        'ngMap',
        'fox.scrollReveal',
        'angularSmoothscroll',
        'angular-owl-carousel-2',
        'angular-loading-bar',
        'swipe',
        '720kb.socialshare'
      ]);

})();

(function () {
  'use strict';
  angular
    .module('frontendApp')
    //establece altura a pantalla completa
    .directive('wleft', function () {
      return {
        templateUrl: 'app/scripts/directives/wleft/wleft.html',
        restrict: 'A',
        replace: true,
        scope: {
          //configuracion basica
          sec: '='
        },
        controller: function wleft($scope, $rootScope, toastr, $state, $location, $log,
                                   localStorageService, $window) {
          console.log('hello from directive');
          $scope.sec = $rootScope.secPicked;


        }
      }
    })
})();

(function () {
  'use strict';
  angular
    .module('frontendApp')
    //establece altura a pantalla completa
    .directive('wright', function () {
      return {
        templateUrl: 'app/scripts/directives/wright/wright.html',
        restrict: 'A',
        replace: true,
        scope: {
          //configuracion basica
          sec: '=',
        },
       // rootScope: $rootScope,

        controller: function wright($scope, $rootScope, toastr, $state, $location, $log,
                                   localStorageService, $window) {
          console.log('hello from directive');

          $scope.sec = $rootScope.secPicked;
          /*switch($rootScope.currentState){
            case 'news-selected':
            case 'area-selected':
              $scope.sec = {
                class: 'inner-view',
                image: '../assets/images/6.jpg',
                title: {
                  es: 'Título de la sección',
                  en: 'Title of the news shown'
                },
                legend: {
                  es: 'La Paz, Bolivia / 02.19',
                  en: 'La Paz, Bolivia / 02.19'
                },
                websectiondata: [
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<h2>Subtitulo de prueba</h2><h3>Subtitulo de prueba</h3><h4>Subtitulo de prueba</h4><h5>Subtitulo de prueba</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p><a>Enlace de prueba</a>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<ul><li><p>Prueba</p></li><li><p>Prueba</p></li></ul>',
                      en: '<h1>Subtitulo de prueba</h1><h2>Subtitulo de prueba</h2><h3>Subtitulo de prueba</h3><h4>Subtitulo de prueba</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p><a>Enlace de prueba</a>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<ul><li><p>Prueba</p></li><li><p>Prueba</p></li></ul>'
                    },
                  },
                  {
                    type: 1,
                    order: 0,
                    image: '../assets/images/2.jpg',
                  },
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      ''
                    }
                  },
                  {
                    type: 3,
                    order: 0,
                    websectiondataitem: [
                      {
                        image: '../assets/images/1.jpg',
                      },
                      {
                        image: '../assets/images/2.jpg',
                      },
                      {
                        image: '../assets/images/3.jpg',
                      }
                    ]
                  },

                  {
                    type: 2,
                    order: 0,
                    link: '8XRSnYzewes',
                  },
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      ''
                    }
                  },
                ]
              };
              break;
            case 'profile-selected':
              $scope.sec = {
                class: 'inner-view',
                image: '../assets/images/6.jpg',
                title: {
                  es: 'Título de la sección',
                  en: 'Title of the news shown'
                },
                legend: {
                  es: 'La Paz, Bolivia / 02.19',
                  en: 'La Paz, Bolivia / 02.19'
                },
                websectiondata: [
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<h2>Subtitulo de prueba</h2><h3>Subtitulo de prueba</h3><h4>Subtitulo de prueba</h4><h5>Subtitulo de prueba</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p><a>Enlace de prueba</a>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<ul><li><p>Prueba</p></li><li><p>Prueba</p></li></ul>',
                      en: '<h1>Subtitulo de prueba</h1><h2>Subtitulo de prueba</h2><h3>Subtitulo de prueba</h3><h4>Subtitulo de prueba</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p><a>Enlace de prueba</a>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<ul><li><p>Prueba</p></li><li><p>Prueba</p></li></ul>'
                    },
                  },
                  {
                    type: 5,
                    content:''
                  }
                ]
              };
              break;
            case 'aboutus':{
              $rootScope.temporalElement('Sobre Nosotros', '../assets/images/4.jpg', '', '');
              $scope.sec = {
                class: 'inner-view',
                image: '../assets/images/6.jpg',
                title: {
                  es: 'Título de la sección',
                  en: 'Title of the news shown'
                },
                legend: {
                  es: 'La Paz, Bolivia / 02.19',
                  en: 'La Paz, Bolivia / 02.19'
                },
                websectiondata: [
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<h2>Subtitulo de prueba</h2><h3>Subtitulo de prueba</h3><h4>Subtitulo de prueba</h4><h5>Subtitulo de prueba</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p><a>Enlace de prueba</a>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<ul><li><p>Prueba</p></li><li><p>Prueba</p></li></ul>',
                      en: '<h1>Subtitulo de prueba</h1><h2>Subtitulo de prueba</h2><h3>Subtitulo de prueba</h3><h4>Subtitulo de prueba</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p><a>Enlace de prueba</a>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<ul><li><p>Prueba</p></li><li><p>Prueba</p></li></ul>'
                    },
                  },
                  {
                    type: 1,
                    order: 0,
                    image: '../assets/images/2.jpg',
                  },
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      ''
                    }
                  },
                  {
                    type: 3,
                    order: 0,
                    websectiondataitem: [
                      {
                        image: '../assets/images/1.jpg',
                      },
                      {
                        image: '../assets/images/2.jpg',
                      },
                      {
                        image: '../assets/images/3.jpg',
                      }
                    ]
                  },

                  {
                    type: 2,
                    order: 0,
                    link: '8XRSnYzewes',
                  },
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      ''
                    }
                  },
                ]
              };
              break;
            }
          }*/


        }
      }
    })
})();

'use strict';
angular
  .module('frontendApp')
  .factory('ContentService', function ($http, $rootScope, $log) {
    return {

      getdata: function (tabla, params) {
        $log.log('GETDATA PARAMS', tabla, params);
        return $http.post($rootScope.api + '/api/' + tabla + '/getdata', params);
      },

      websearch: function ( params) {
        $log.log('WEBSEARCH PARAMS', params);
        return $http.post($rootScope.api + '/api/websearch', params);
      },

      webcontent: function (state, params) {
        params['state'] = state;
        $log.log('WEBCONTENT PARAMS', params);
        return $http.post($rootScope.api + '/api/webcontent', params);
      },

      sendform: function (params) {
        return $http.post($rootScope.api + '/api/sendform', params);
      }


    };
  });

/**
 * Created by FER-PC-WIN10 on 03/05/2016.
 */
(function () {
  'use strict';
  angular
    .module('frontendApp')
    .directive('renderHtml', function ($compile) {
      return function (scope, element, attrs) {
        scope.$watch(
          function (scope) {
            return scope.$eval(attrs.renderHtml);
          },
          function (value) {
            element.html(value);
            $compile(element.contents())(scope);
          }
        );
      };
    });
})();

/* -----------------------------------------------
 /* Author : Vincent Garreau  - vincentgarreau.com
 /* MIT license: http://opensource.org/licenses/MIT
 /* Demo / Generator : vincentgarreau.com/particles.js
 /* GitHub : github.com/VincentGarreau/particles.js
 /* How to use? : Check the GitHub README
 /* v2.0.0
 /* ----------------------------------------------- */
function hexToRgb(e) {
  var a = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  e = e.replace(a, function (e, a, t, i) {
    return a + a + t + t + i + i
  });
  var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? {r: parseInt(t[1], 16), g: parseInt(t[2], 16), b: parseInt(t[3], 16)} : null
}
function clamp(e, a, t) {
  return Math.min(Math.max(e, a), t)
}
function isInArray(e, a) {
  return a.indexOf(e) > -1
}
var pJS = function (e, a) {
  var t = document.querySelector("#" + e + " > .particles-js-canvas-el");
  this.pJS = {
    canvas: {el: t, w: t.offsetWidth, h: t.offsetHeight},
    particles: {
      number: {value: 400, density: {enable: !0, value_area: 800}},
      color: {value: "#fff"},
      shape: {
        type: "circle",
        stroke: {width: 0, color: "#ff0000"},
        polygon: {nb_sides: 5},
        image: {src: "", width: 100, height: 100}
      },
      opacity: {value: 1, random: !1, anim: {enable: !1, speed: 2, opacity_min: 0, sync: !1}},
      size: {value: 20, random: !1, anim: {enable: !1, speed: 20, size_min: 0, sync: !1}},
      line_linked: {enable: !0, distance: 100, color: "#fff", opacity: 1, width: 1},
      move: {
        enable: !0,
        speed: 2,
        direction: "none",
        random: !1,
        straight: !1,
        out_mode: "out",
        bounce: !1,
        attract: {enable: !1, rotateX: 3e3, rotateY: 3e3}
      },
      array: []
    },
    interactivity: {
      detect_on: "canvas",
      events: {onhover: {enable: !0, mode: "grab"}, onclick: {enable: !0, mode: "push"}, resize: !0},
      modes: {
        grab: {distance: 100, line_linked: {opacity: 1}},
        bubble: {distance: 200, size: 80, duration: .4},
        repulse: {distance: 200, duration: .4},
        push: {particles_nb: 4},
        remove: {particles_nb: 2}
      },
      mouse: {}
    },
    retina_detect: !1,
    fn: {interact: {}, modes: {}, vendors: {}},
    tmp: {}
  };
  var i = this.pJS;
  a && Object.deepExtend(i, a), i.tmp.obj = {
    size_value: i.particles.size.value,
    size_anim_speed: i.particles.size.anim.speed,
    move_speed: i.particles.move.speed,
    line_linked_distance: i.particles.line_linked.distance,
    line_linked_width: i.particles.line_linked.width,
    mode_grab_distance: i.interactivity.modes.grab.distance,
    mode_bubble_distance: i.interactivity.modes.bubble.distance,
    mode_bubble_size: i.interactivity.modes.bubble.size,
    mode_repulse_distance: i.interactivity.modes.repulse.distance
  }, i.fn.retinaInit = function () {
    i.retina_detect && window.devicePixelRatio > 1 ? (i.canvas.pxratio = window.devicePixelRatio, i.tmp.retina = !0) : (i.canvas.pxratio = 1, i.tmp.retina = !1), i.canvas.w = i.canvas.el.offsetWidth * i.canvas.pxratio, i.canvas.h = i.canvas.el.offsetHeight * i.canvas.pxratio, i.particles.size.value = i.tmp.obj.size_value * i.canvas.pxratio, i.particles.size.anim.speed = i.tmp.obj.size_anim_speed * i.canvas.pxratio, i.particles.move.speed = i.tmp.obj.move_speed * i.canvas.pxratio, i.particles.line_linked.distance = i.tmp.obj.line_linked_distance * i.canvas.pxratio, i.interactivity.modes.grab.distance = i.tmp.obj.mode_grab_distance * i.canvas.pxratio, i.interactivity.modes.bubble.distance = i.tmp.obj.mode_bubble_distance * i.canvas.pxratio, i.particles.line_linked.width = i.tmp.obj.line_linked_width * i.canvas.pxratio, i.interactivity.modes.bubble.size = i.tmp.obj.mode_bubble_size * i.canvas.pxratio, i.interactivity.modes.repulse.distance = i.tmp.obj.mode_repulse_distance * i.canvas.pxratio
  }, i.fn.canvasInit = function () {
    i.canvas.ctx = i.canvas.el.getContext("2d")
  }, i.fn.canvasSize = function () {
    i.canvas.el.width = i.canvas.w, i.canvas.el.height = i.canvas.h, i && i.interactivity.events.resize && window.addEventListener("resize", function () {
      i.canvas.w = i.canvas.el.offsetWidth, i.canvas.h = i.canvas.el.offsetHeight, i.tmp.retina && (i.canvas.w *= i.canvas.pxratio, i.canvas.h *= i.canvas.pxratio), i.canvas.el.width = i.canvas.w, i.canvas.el.height = i.canvas.h, i.particles.move.enable || (i.fn.particlesEmpty(), i.fn.particlesCreate(), i.fn.particlesDraw(), i.fn.vendors.densityAutoParticles()), i.fn.vendors.densityAutoParticles()
    })
  }, i.fn.canvasPaint = function () {
    i.canvas.ctx.fillRect(0, 0, i.canvas.w, i.canvas.h)
  }, i.fn.canvasClear = function () {
    i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h)
  }, i.fn.particle = function (e, a, t) {
    if (this.radius = (i.particles.size.random ? Math.random() : 1) * i.particles.size.value, i.particles.size.anim.enable && (this.size_status = !1, this.vs = i.particles.size.anim.speed / 100, i.particles.size.anim.sync || (this.vs = this.vs * Math.random())), this.x = t ? t.x : Math.random() * i.canvas.w, this.y = t ? t.y : Math.random() * i.canvas.h, this.x > i.canvas.w - 2 * this.radius ? this.x = this.x - this.radius : this.x < 2 * this.radius && (this.x = this.x + this.radius), this.y > i.canvas.h - 2 * this.radius ? this.y = this.y - this.radius : this.y < 2 * this.radius && (this.y = this.y + this.radius), i.particles.move.bounce && i.fn.vendors.checkOverlap(this, t), this.color = {}, "object" == typeof e.value)if (e.value instanceof Array) {
      var s = e.value[Math.floor(Math.random() * i.particles.color.value.length)];
      this.color.rgb = hexToRgb(s)
    } else void 0 != e.value.r && void 0 != e.value.g && void 0 != e.value.b && (this.color.rgb = {
      r: e.value.r,
      g: e.value.g,
      b: e.value.b
    }), void 0 != e.value.h && void 0 != e.value.s && void 0 != e.value.l && (this.color.hsl = {
      h: e.value.h,
      s: e.value.s,
      l: e.value.l
    }); else"random" == e.value ? this.color.rgb = {
      r: Math.floor(256 * Math.random()) + 0,
      g: Math.floor(256 * Math.random()) + 0,
      b: Math.floor(256 * Math.random()) + 0
    } : "string" == typeof e.value && (this.color = e, this.color.rgb = hexToRgb(this.color.value));
    this.opacity = (i.particles.opacity.random ? Math.random() : 1) * i.particles.opacity.value, i.particles.opacity.anim.enable && (this.opacity_status = !1, this.vo = i.particles.opacity.anim.speed / 100, i.particles.opacity.anim.sync || (this.vo = this.vo * Math.random()));
    var n = {};
    switch (i.particles.move.direction) {
      case"top":
        n = {x: 0, y: -1};
        break;
      case"top-right":
        n = {x: .5, y: -.5};
        break;
      case"right":
        n = {x: 1, y: -0};
        break;
      case"bottom-right":
        n = {x: .5, y: .5};
        break;
      case"bottom":
        n = {x: 0, y: 1};
        break;
      case"bottom-left":
        n = {x: -.5, y: 1};
        break;
      case"left":
        n = {x: -1, y: 0};
        break;
      case"top-left":
        n = {x: -.5, y: -.5};
        break;
      default:
        n = {x: 0, y: 0}
    }
    i.particles.move.straight ? (this.vx = n.x, this.vy = n.y, i.particles.move.random && (this.vx = this.vx * Math.random(), this.vy = this.vy * Math.random())) : (this.vx = n.x + Math.random() - .5, this.vy = n.y + Math.random() - .5), this.vx_i = this.vx, this.vy_i = this.vy;
    var r = i.particles.shape.type;
    if ("object" == typeof r) {
      if (r instanceof Array) {
        var c = r[Math.floor(Math.random() * r.length)];
        this.shape = c
      }
    } else this.shape = r;
    if ("image" == this.shape) {
      var o = i.particles.shape;
      this.img = {
        src: o.image.src,
        ratio: o.image.width / o.image.height
      }, this.img.ratio || (this.img.ratio = 1), "svg" == i.tmp.img_type && void 0 != i.tmp.source_svg && (i.fn.vendors.createSvgImg(this), i.tmp.pushing && (this.img.loaded = !1))
    }
  }, i.fn.particle.prototype.draw = function () {
    function e() {
      i.canvas.ctx.drawImage(r, a.x - t, a.y - t, 2 * t, 2 * t / a.img.ratio)
    }

    var a = this;
    if (void 0 != a.radius_bubble)var t = a.radius_bubble; else var t = a.radius;
    if (void 0 != a.opacity_bubble)var s = a.opacity_bubble; else var s = a.opacity;
    if (a.color.rgb)var n = "rgba(" + a.color.rgb.r + "," + a.color.rgb.g + "," + a.color.rgb.b + "," + s + ")"; else var n = "hsla(" + a.color.hsl.h + "," + a.color.hsl.s + "%," + a.color.hsl.l + "%," + s + ")";
    switch (i.canvas.ctx.fillStyle = n, i.canvas.ctx.beginPath(), a.shape) {
      case"circle":
        i.canvas.ctx.arc(a.x, a.y, t, 0, 2 * Math.PI, !1);
        break;
      case"edge":
        i.canvas.ctx.rect(a.x - t, a.y - t, 2 * t, 2 * t);
        break;
      case"triangle":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - t, a.y + t / 1.66, 2 * t, 3, 2);
        break;
      case"polygon":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - t / (i.particles.shape.polygon.nb_sides / 3.5), a.y - t / .76, 2.66 * t / (i.particles.shape.polygon.nb_sides / 3), i.particles.shape.polygon.nb_sides, 1);
        break;
      case"star":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - 2 * t / (i.particles.shape.polygon.nb_sides / 4), a.y - t / 1.52, 2 * t * 2.66 / (i.particles.shape.polygon.nb_sides / 3), i.particles.shape.polygon.nb_sides, 2);
        break;
      case"image":
        if ("svg" == i.tmp.img_type)var r = a.img.obj; else var r = i.tmp.img_obj;
        r && e()
    }
    i.canvas.ctx.closePath(), i.particles.shape.stroke.width > 0 && (i.canvas.ctx.strokeStyle = i.particles.shape.stroke.color, i.canvas.ctx.lineWidth = i.particles.shape.stroke.width, i.canvas.ctx.stroke()), i.canvas.ctx.fill()
  }, i.fn.particlesCreate = function () {
    for (var e = 0; e < i.particles.number.value; e++)i.particles.array.push(new i.fn.particle(i.particles.color, i.particles.opacity.value))
  }, i.fn.particlesUpdate = function () {
    for (var e = 0; e < i.particles.array.length; e++) {
      var a = i.particles.array[e];
      if (i.particles.move.enable) {
        var t = i.particles.move.speed / 2;
        a.x += a.vx * t, a.y += a.vy * t
      }
      if (i.particles.opacity.anim.enable && (1 == a.opacity_status ? (a.opacity >= i.particles.opacity.value && (a.opacity_status = !1), a.opacity += a.vo) : (a.opacity <= i.particles.opacity.anim.opacity_min && (a.opacity_status = !0), a.opacity -= a.vo), a.opacity < 0 && (a.opacity = 0)), i.particles.size.anim.enable && (1 == a.size_status ? (a.radius >= i.particles.size.value && (a.size_status = !1), a.radius += a.vs) : (a.radius <= i.particles.size.anim.size_min && (a.size_status = !0), a.radius -= a.vs), a.radius < 0 && (a.radius = 0)), "bounce" == i.particles.move.out_mode)var s = {
        x_left: a.radius,
        x_right: i.canvas.w,
        y_top: a.radius,
        y_bottom: i.canvas.h
      }; else var s = {
        x_left: -a.radius,
        x_right: i.canvas.w + a.radius,
        y_top: -a.radius,
        y_bottom: i.canvas.h + a.radius
      };
      switch (a.x - a.radius > i.canvas.w ? (a.x = s.x_left, a.y = Math.random() * i.canvas.h) : a.x + a.radius < 0 && (a.x = s.x_right, a.y = Math.random() * i.canvas.h), a.y - a.radius > i.canvas.h ? (a.y = s.y_top, a.x = Math.random() * i.canvas.w) : a.y + a.radius < 0 && (a.y = s.y_bottom, a.x = Math.random() * i.canvas.w), i.particles.move.out_mode) {
        case"bounce":
          a.x + a.radius > i.canvas.w ? a.vx = -a.vx : a.x - a.radius < 0 && (a.vx = -a.vx), a.y + a.radius > i.canvas.h ? a.vy = -a.vy : a.y - a.radius < 0 && (a.vy = -a.vy)
      }
      if (isInArray("grab", i.interactivity.events.onhover.mode) && i.fn.modes.grabParticle(a), (isInArray("bubble", i.interactivity.events.onhover.mode) || isInArray("bubble", i.interactivity.events.onclick.mode)) && i.fn.modes.bubbleParticle(a), (isInArray("repulse", i.interactivity.events.onhover.mode) || isInArray("repulse", i.interactivity.events.onclick.mode)) && i.fn.modes.repulseParticle(a), i.particles.line_linked.enable || i.particles.move.attract.enable)for (var n = e + 1; n < i.particles.array.length; n++) {
        var r = i.particles.array[n];
        i.particles.line_linked.enable && i.fn.interact.linkParticles(a, r), i.particles.move.attract.enable && i.fn.interact.attractParticles(a, r), i.particles.move.bounce && i.fn.interact.bounceParticles(a, r)
      }
    }
  }, i.fn.particlesDraw = function () {
    i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h), i.fn.particlesUpdate();
    for (var e = 0; e < i.particles.array.length; e++) {
      var a = i.particles.array[e];
      a.draw()
    }
  }, i.fn.particlesEmpty = function () {
    i.particles.array = []
  }, i.fn.particlesRefresh = function () {
    cancelRequestAnimFrame(i.fn.checkAnimFrame), cancelRequestAnimFrame(i.fn.drawAnimFrame), i.tmp.source_svg = void 0, i.tmp.img_obj = void 0, i.tmp.count_svg = 0, i.fn.particlesEmpty(), i.fn.canvasClear(), i.fn.vendors.start()
  }, i.fn.interact.linkParticles = function (e, a) {
    var t = e.x - a.x, s = e.y - a.y, n = Math.sqrt(t * t + s * s);
    if (n <= i.particles.line_linked.distance) {
      var r = i.particles.line_linked.opacity - n / (1 / i.particles.line_linked.opacity) / i.particles.line_linked.distance;
      if (r > 0) {
        var c = i.particles.line_linked.color_rgb_line;
        i.canvas.ctx.strokeStyle = "rgba(" + c.r + "," + c.g + "," + c.b + "," + r + ")", i.canvas.ctx.lineWidth = i.particles.line_linked.width, i.canvas.ctx.beginPath(), i.canvas.ctx.moveTo(e.x, e.y), i.canvas.ctx.lineTo(a.x, a.y), i.canvas.ctx.stroke(), i.canvas.ctx.closePath()
      }
    }
  }, i.fn.interact.attractParticles = function (e, a) {
    var t = e.x - a.x, s = e.y - a.y, n = Math.sqrt(t * t + s * s);
    if (n <= i.particles.line_linked.distance) {
      var r = t / (1e3 * i.particles.move.attract.rotateX), c = s / (1e3 * i.particles.move.attract.rotateY);
      e.vx -= r, e.vy -= c, a.vx += r, a.vy += c
    }
  }, i.fn.interact.bounceParticles = function (e, a) {
    var t = e.x - a.x, i = e.y - a.y, s = Math.sqrt(t * t + i * i), n = e.radius + a.radius;
    n >= s && (e.vx = -e.vx, e.vy = -e.vy, a.vx = -a.vx, a.vy = -a.vy)
  }, i.fn.modes.pushParticles = function (e, a) {
    i.tmp.pushing = !0;
    for (var t = 0; e > t; t++)i.particles.array.push(new i.fn.particle(i.particles.color, i.particles.opacity.value, {
      x: a ? a.pos_x : Math.random() * i.canvas.w,
      y: a ? a.pos_y : Math.random() * i.canvas.h
    })), t == e - 1 && (i.particles.move.enable || i.fn.particlesDraw(), i.tmp.pushing = !1)
  }, i.fn.modes.removeParticles = function (e) {
    i.particles.array.splice(0, e), i.particles.move.enable || i.fn.particlesDraw()
  }, i.fn.modes.bubbleParticle = function (e) {
    function a() {
      e.opacity_bubble = e.opacity, e.radius_bubble = e.radius
    }

    function t(a, t, s, n, c) {
      if (a != t)if (i.tmp.bubble_duration_end) {
        if (void 0 != s) {
          var o = n - p * (n - a) / i.interactivity.modes.bubble.duration, l = a - o;
          d = a + l, "size" == c && (e.radius_bubble = d), "opacity" == c && (e.opacity_bubble = d)
        }
      } else if (r <= i.interactivity.modes.bubble.distance) {
        if (void 0 != s)var v = s; else var v = n;
        if (v != a) {
          var d = n - p * (n - a) / i.interactivity.modes.bubble.duration;
          "size" == c && (e.radius_bubble = d), "opacity" == c && (e.opacity_bubble = d)
        }
      } else"size" == c && (e.radius_bubble = void 0), "opacity" == c && (e.opacity_bubble = void 0)
    }

    if (i.interactivity.events.onhover.enable && isInArray("bubble", i.interactivity.events.onhover.mode)) {
      var s = e.x - i.interactivity.mouse.pos_x, n = e.y - i.interactivity.mouse.pos_y, r = Math.sqrt(s * s + n * n), c = 1 - r / i.interactivity.modes.bubble.distance;
      if (r <= i.interactivity.modes.bubble.distance) {
        if (c >= 0 && "mousemove" == i.interactivity.status) {
          if (i.interactivity.modes.bubble.size != i.particles.size.value)if (i.interactivity.modes.bubble.size > i.particles.size.value) {
            var o = e.radius + i.interactivity.modes.bubble.size * c;
            o >= 0 && (e.radius_bubble = o)
          } else {
            var l = e.radius - i.interactivity.modes.bubble.size, o = e.radius - l * c;
            o > 0 ? e.radius_bubble = o : e.radius_bubble = 0
          }
          if (i.interactivity.modes.bubble.opacity != i.particles.opacity.value)if (i.interactivity.modes.bubble.opacity > i.particles.opacity.value) {
            var v = i.interactivity.modes.bubble.opacity * c;
            v > e.opacity && v <= i.interactivity.modes.bubble.opacity && (e.opacity_bubble = v)
          } else {
            var v = e.opacity - (i.particles.opacity.value - i.interactivity.modes.bubble.opacity) * c;
            v < e.opacity && v >= i.interactivity.modes.bubble.opacity && (e.opacity_bubble = v)
          }
        }
      } else a();
      "mouseleave" == i.interactivity.status && a()
    } else if (i.interactivity.events.onclick.enable && isInArray("bubble", i.interactivity.events.onclick.mode)) {
      if (i.tmp.bubble_clicking) {
        var s = e.x - i.interactivity.mouse.click_pos_x, n = e.y - i.interactivity.mouse.click_pos_y, r = Math.sqrt(s * s + n * n), p = ((new Date).getTime() - i.interactivity.mouse.click_time) / 1e3;
        p > i.interactivity.modes.bubble.duration && (i.tmp.bubble_duration_end = !0), p > 2 * i.interactivity.modes.bubble.duration && (i.tmp.bubble_clicking = !1, i.tmp.bubble_duration_end = !1)
      }
      i.tmp.bubble_clicking && (t(i.interactivity.modes.bubble.size, i.particles.size.value, e.radius_bubble, e.radius, "size"), t(i.interactivity.modes.bubble.opacity, i.particles.opacity.value, e.opacity_bubble, e.opacity, "opacity"))
    }
  }, i.fn.modes.repulseParticle = function (e) {
    function a() {
      var a = Math.atan2(d, p);
      if (e.vx = u * Math.cos(a), e.vy = u * Math.sin(a), "bounce" == i.particles.move.out_mode) {
        var t = {x: e.x + e.vx, y: e.y + e.vy};
        t.x + e.radius > i.canvas.w ? e.vx = -e.vx : t.x - e.radius < 0 && (e.vx = -e.vx), t.y + e.radius > i.canvas.h ? e.vy = -e.vy : t.y - e.radius < 0 && (e.vy = -e.vy)
      }
    }

    if (i.interactivity.events.onhover.enable && isInArray("repulse", i.interactivity.events.onhover.mode) && "mousemove" == i.interactivity.status) {
      var t = e.x - i.interactivity.mouse.pos_x, s = e.y - i.interactivity.mouse.pos_y, n = Math.sqrt(t * t + s * s), r = {
        x: t / n,
        y: s / n
      }, c = i.interactivity.modes.repulse.distance, o = 100, l = clamp(1 / c * (-1 * Math.pow(n / c, 2) + 1) * c * o, 0, 50), v = {
        x: e.x + r.x * l,
        y: e.y + r.y * l
      };
      "bounce" == i.particles.move.out_mode ? (v.x - e.radius > 0 && v.x + e.radius < i.canvas.w && (e.x = v.x), v.y - e.radius > 0 && v.y + e.radius < i.canvas.h && (e.y = v.y)) : (e.x = v.x, e.y = v.y)
    } else if (i.interactivity.events.onclick.enable && isInArray("repulse", i.interactivity.events.onclick.mode))if (i.tmp.repulse_finish || (i.tmp.repulse_count++, i.tmp.repulse_count == i.particles.array.length && (i.tmp.repulse_finish = !0)), i.tmp.repulse_clicking) {
      var c = Math.pow(i.interactivity.modes.repulse.distance / 6, 3), p = i.interactivity.mouse.click_pos_x - e.x, d = i.interactivity.mouse.click_pos_y - e.y, m = p * p + d * d, u = -c / m * 1;
      c >= m && a()
    } else 0 == i.tmp.repulse_clicking && (e.vx = e.vx_i, e.vy = e.vy_i)
  }, i.fn.modes.grabParticle = function (e) {
    if (i.interactivity.events.onhover.enable && "mousemove" == i.interactivity.status) {
      var a = e.x - i.interactivity.mouse.pos_x, t = e.y - i.interactivity.mouse.pos_y, s = Math.sqrt(a * a + t * t);
      if (s <= i.interactivity.modes.grab.distance) {
        var n = i.interactivity.modes.grab.line_linked.opacity - s / (1 / i.interactivity.modes.grab.line_linked.opacity) / i.interactivity.modes.grab.distance;
        if (n > 0) {
          var r = i.particles.line_linked.color_rgb_line;
          i.canvas.ctx.strokeStyle = "rgba(" + r.r + "," + r.g + "," + r.b + "," + n + ")", i.canvas.ctx.lineWidth = i.particles.line_linked.width, i.canvas.ctx.beginPath(), i.canvas.ctx.moveTo(e.x, e.y), i.canvas.ctx.lineTo(i.interactivity.mouse.pos_x, i.interactivity.mouse.pos_y), i.canvas.ctx.stroke(), i.canvas.ctx.closePath()
        }
      }
    }
  }, i.fn.vendors.eventsListeners = function () {
    "window" == i.interactivity.detect_on ? i.interactivity.el = window : i.interactivity.el = i.canvas.el, (i.interactivity.events.onhover.enable || i.interactivity.events.onclick.enable) && (i.interactivity.el.addEventListener("mousemove", function (e) {
      if (i.interactivity.el == window)var a = e.clientX, t = e.clientY; else var a = e.offsetX || e.clientX, t = e.offsetY || e.clientY;
      i.interactivity.mouse.pos_x = a, i.interactivity.mouse.pos_y = t, i.tmp.retina && (i.interactivity.mouse.pos_x *= i.canvas.pxratio, i.interactivity.mouse.pos_y *= i.canvas.pxratio), i.interactivity.status = "mousemove"
    }), i.interactivity.el.addEventListener("mouseleave", function (e) {
      i.interactivity.mouse.pos_x = null, i.interactivity.mouse.pos_y = null, i.interactivity.status = "mouseleave"
    })), i.interactivity.events.onclick.enable && i.interactivity.el.addEventListener("click", function () {
      if (i.interactivity.mouse.click_pos_x = i.interactivity.mouse.pos_x, i.interactivity.mouse.click_pos_y = i.interactivity.mouse.pos_y, i.interactivity.mouse.click_time = (new Date).getTime(), i.interactivity.events.onclick.enable)switch (i.interactivity.events.onclick.mode) {
        case"push":
          i.particles.move.enable ? i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb, i.interactivity.mouse) : 1 == i.interactivity.modes.push.particles_nb ? i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb, i.interactivity.mouse) : i.interactivity.modes.push.particles_nb > 1 && i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb);
          break;
        case"remove":
          i.fn.modes.removeParticles(i.interactivity.modes.remove.particles_nb);
          break;
        case"bubble":
          i.tmp.bubble_clicking = !0;
          break;
        case"repulse":
          i.tmp.repulse_clicking = !0, i.tmp.repulse_count = 0, i.tmp.repulse_finish = !1, setTimeout(function () {
            i.tmp.repulse_clicking = !1
          }, 1e3 * i.interactivity.modes.repulse.duration)
      }
    })
  }, i.fn.vendors.densityAutoParticles = function () {
    if (i.particles.number.density.enable) {
      var e = i.canvas.el.width * i.canvas.el.height / 1e3;
      i.tmp.retina && (e /= 2 * i.canvas.pxratio);
      var a = e * i.particles.number.value / i.particles.number.density.value_area, t = i.particles.array.length - a;
      0 > t ? i.fn.modes.pushParticles(Math.abs(t)) : i.fn.modes.removeParticles(t)
    }
  }, i.fn.vendors.checkOverlap = function (e, a) {
    for (var t = 0; t < i.particles.array.length; t++) {
      var s = i.particles.array[t], n = e.x - s.x, r = e.y - s.y, c = Math.sqrt(n * n + r * r);
      c <= e.radius + s.radius && (e.x = a ? a.x : Math.random() * i.canvas.w, e.y = a ? a.y : Math.random() * i.canvas.h, i.fn.vendors.checkOverlap(e))
    }
  }, i.fn.vendors.createSvgImg = function (e) {
    var a = i.tmp.source_svg, t = /#([0-9A-F]{3,6})/gi, s = a.replace(t, function (a, t, i, s) {
      if (e.color.rgb)var n = "rgba(" + e.color.rgb.r + "," + e.color.rgb.g + "," + e.color.rgb.b + "," + e.opacity + ")"; else var n = "hsla(" + e.color.hsl.h + "," + e.color.hsl.s + "%," + e.color.hsl.l + "%," + e.opacity + ")";
      return n
    }), n = new Blob([s], {type: "image/svg+xml;charset=utf-8"}), r = window.URL || window.webkitURL || window, c = r.createObjectURL(n), o = new Image;
    o.addEventListener("load", function () {
      e.img.obj = o, e.img.loaded = !0, r.revokeObjectURL(c), i.tmp.count_svg++
    }), o.src = c
  }, i.fn.vendors.destroypJS = function () {
    cancelAnimationFrame(i.fn.drawAnimFrame), t.remove(), pJSDom = null
  }, i.fn.vendors.drawShape = function (e, a, t, i, s, n) {
    var r = s * n, c = s / n, o = 180 * (c - 2) / c, l = Math.PI - Math.PI * o / 180;
    e.save(), e.beginPath(), e.translate(a, t), e.moveTo(0, 0);
    for (var v = 0; r > v; v++)e.lineTo(i, 0), e.translate(i, 0), e.rotate(l);
    e.fill(), e.restore()
  }, i.fn.vendors.exportImg = function () {
    window.open(i.canvas.el.toDataURL("image/png"), "_blank")
  }, i.fn.vendors.loadImg = function (e) {
    if (i.tmp.img_error = void 0, "" != i.particles.shape.image.src)if ("svg" == e) {
      var a = new XMLHttpRequest;
      a.open("GET", i.particles.shape.image.src), a.onreadystatechange = function (e) {
        4 == a.readyState && (200 == a.status ? (i.tmp.source_svg = e.currentTarget.response, i.fn.vendors.checkBeforeDraw()) : (console.log("Error pJS - Image not found"), i.tmp.img_error = !0))
      }, a.send()
    } else {
      var t = new Image;
      t.addEventListener("load", function () {
        i.tmp.img_obj = t, i.fn.vendors.checkBeforeDraw()
      }), t.src = i.particles.shape.image.src
    } else console.log("Error pJS - No image.src"), i.tmp.img_error = !0
  }, i.fn.vendors.draw = function () {
    "image" == i.particles.shape.type ? "svg" == i.tmp.img_type ? i.tmp.count_svg >= i.particles.number.value ? (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame)) : i.tmp.img_error || (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw)) : void 0 != i.tmp.img_obj ? (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame)) : i.tmp.img_error || (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw)) : (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame))
  }, i.fn.vendors.checkBeforeDraw = function () {
    "image" == i.particles.shape.type ? "svg" == i.tmp.img_type && void 0 == i.tmp.source_svg ? i.tmp.checkAnimFrame = requestAnimFrame(check) : (cancelRequestAnimFrame(i.tmp.checkAnimFrame), i.tmp.img_error || (i.fn.vendors.init(), i.fn.vendors.draw())) : (i.fn.vendors.init(), i.fn.vendors.draw())
  }, i.fn.vendors.init = function () {
    i.fn.retinaInit(), i.fn.canvasInit(), i.fn.canvasSize(), i.fn.canvasPaint(), i.fn.particlesCreate(), i.fn.vendors.densityAutoParticles(), i.particles.line_linked.color_rgb_line = hexToRgb(i.particles.line_linked.color)
  }, i.fn.vendors.start = function () {
    isInArray("image", i.particles.shape.type) ? (i.tmp.img_type = i.particles.shape.image.src.substr(i.particles.shape.image.src.length - 3), i.fn.vendors.loadImg(i.tmp.img_type)) : i.fn.vendors.checkBeforeDraw()
  }, i.fn.vendors.eventsListeners(), i.fn.vendors.start()
};
Object.deepExtend = function (e, a) {
  for (var t in a)a[t] && a[t].constructor && a[t].constructor === Object ? (e[t] = e[t] || {}, arguments.callee(e[t], a[t])) : e[t] = a[t];
  return e
}, window.requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (e) {
      window.setTimeout(e, 1e3 / 60)
    }
}(), window.cancelRequestAnimFrame = function () {
  return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || clearTimeout
}(), window.pJSDom = [], window.particlesJS = function (e, a) {
  "string" != typeof e && (a = e, e = "particles-js"), e || (e = "particles-js");
  var t = document.getElementById(e), i = "particles-js-canvas-el", s = t.getElementsByClassName(i);
  if (s.length)for (; s.length > 0;)t.removeChild(s[0]);
  var n = document.createElement("canvas");
  n.className = i, n.style.width = "100%", n.style.height = "100%";
  var r = document.getElementById(e).appendChild(n);
  null != r && pJSDom.push(new pJS(e, a))
}, window.particlesJS.load = function (e, a, t) {
  var i = new XMLHttpRequest;
  i.open("GET", a), i.onreadystatechange = function (a) {
    if (4 == i.readyState)if (200 == i.status) {
      var s = JSON.parse(a.currentTarget.response);
      window.particlesJS(e, s), t && t()
    } else console.log("Error pJS - XMLHttpRequest status: " + i.status), console.log("Error pJS - File config not found")
  }, i.send()
};
/**
 * Created by DELL on 18/7/2018.
 */

(function () {
  'use strict';
  angular
    .module('frontendApp')
    //establece altura a pantalla completa
    .directive('scrolldetect', function ($window, $rootScope) {
      return {
        restrict: 'A',
        link: function (scope, element, rootScope) {
          var lastScrollTop = 0;
          angular.element($window).bind("scroll", function() {
            var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
            if (st > lastScrollTop){
              // downscroll code
              //console.log('downscroll code');
              $rootScope.scrollDir = 'down';
            } else {
              //console.log('upscroll code');
              $rootScope.scrollDir = 'up';
            }
            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
            scope.$apply();
          });

        }
      };
    })
    .directive('loader', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
            //console.log('exit')
          }).resize();
        }
      };
    })
    .directive('windowheight', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
            //console.log('exit')
          }).resize();
        }
      };
    })
    .directive('windowheight2', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
         //   element.css({maxHeight: $(window).height()});
          //  element.css({overflowY: 'scroll'});
            element.css({overflowX: 'visible'});
            element.css({overflowY: 'visible'});
            /*if($(window).width() >= 1024){
              element.css({overflowY: 'scroll'});
            }
            else{
              element.css({overflowY: 'visible'});
            }*/
            //console.log('exit')
          }).resize();
        }
      };
    })
    .directive('windowhalf', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
          /*  var size = ($(window).width()/2)/300;
            var total = Math.round(size);*/
            var mobile = ($(window).width() >= 1024) ? 2 : 1;
            var totalwidth = (parseInt($(window).width() / mobile) / 300);
            var size = (Math.floor(totalwidth)) * 300;

            element.css({width: size});
            //console.log('exit')
          }).resize();
        }
      };
    })
    .directive('windowsearch', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
          /*  var size = ($(window).width()/2)/300;
            var total = Math.round(size);*/
            var mobile = ($(window).width() >= 1024) ? 1 : 1;
            var totalwidth = (parseInt($(window).width() / mobile) / 300);
            var size = (Math.floor(totalwidth)) * 300;

            element.css({width: size});
            //console.log('exit')
          }).resize();
        }
      };
    })
    //carga video
    .directive('myYoutube', function ($sce) {
      return {
        restrict: 'A',
        scope: {code: '='},
        replace: true,
        template: '<div style="width:100%;"><iframe style="overflow:hidden;height:400px;width:100%" width="100%" height="100%" src="{{url}}" frameborder="0" allowfullscreen></iframe></div>',
        link: function (scope) {
          //console.log('here');
          scope.$watch('code', function (newVal) {
            if (newVal) {
              scope.url = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + newVal);
            }
          });
        }
      };
    })
    //Iguala altura entre elementos
    //targetclass = nombre de la clase para igualar alturas de elementos
    .directive('equalheight', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          targetclass: '@',
          full: '=',
        },
        link: function (scope, element) {
          $(window).resize(function () {
            //console.log('targetclass',scope.targetclass);
            $timeout(function () {
              var x = document.getElementsByClassName(scope.targetclass);
              var temp = 0;
              for (var i = 0; i < x.length; i++) {
                if (temp < x[i].offsetHeight) {
                  temp = x[i].offsetHeight;
                }
              }
              element.css({minHeight: temp});
            }, 1000);
          }).resize();
        }
      };
    }).directive('magazine', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          targetclass: '@',
        },
        link: function (scope, element) {
          $(window).resize(function () {
            console.log('targetclass',scope.targetclass);
            $timeout(function () {
              var x = document.getElementsByClassName(scope.targetclass);
              element.css({minHeight: x[0].offsetWidth*1.25});
            }, 1000);
          }).resize();
        }
      };
    })
    //Iguala altura entre elementos
    //targetclass = nombre de la clase para igualar alturas de elementos
    .directive('squareheight', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          targetclass: '@'
        },
        link: function (scope, element) {
          $(window).resize(function () {
            console.log('targetclass', scope.targetclass)
            $timeout(function () {
              var x = document.getElementsByClassName(scope.targetclass);
              var temp = 0;
              for (var i = 0; i < x.length; i++) {
                if (temp < x[i].offsetWidth) {
                  temp = x[i].offsetWidth;
                }
              }

              //console.log('maximo altura detectada', temp);
              element.css({minHeight: temp});
              element.css({maxHeight: temp});
              element.css({height: temp});
            }, 1000);
          }).resize();
        }
      };
    })
    //establece una altura personalizada partiendo del alto de pantalla o deua medida especifica
    .directive('customheight', function () {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '=',
          autoscroll: '=',
          lockscroll:'='
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var customHeight = $(window).height();
            if (scope.equal) {
              customHeight = scope.equal;
            }
            if (scope.minus) {
              customHeight -= scope.minus;
            }
            if (scope.plus) {
              customHeight += scope.plus;
            }
            if (scope.autoscroll == true) {
              element.css({maxHeight: customHeight});
              element.css({overflowY: 'scroll'});
            }
            element.css({minHeight: customHeight});
            if(scope.lockscroll==true){
              element.css({maxHeight: customHeight});
              element.css({overflow: 'hidden'});
            }
          }).resize();
        }
      };
    })
    //scroll control
    .directive('scroll', function () {
      return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
          elem.on('scroll', function (e) {
            console.log('detecta')
          });
        }
      };
    })
})();

'use strict';
angular
  .module('frontendApp')
  .controller('HomeController',function ($state, $log, $rootScope, $scope,$timeout,toastr,
                                         ContentService) {
    var vm = this;
    $log.debug('HomeController');


 /*   vm.preload = function(){
      vm.alias = $state.params.alias;
      ContentService.getdata('websection', {
        filters: {
          name: {
            value: vm.alias,
            operator: 'like'
          }
        }
      })
        .success(function (res) {
          console.log('salida res', res);
          if (res.status) {

          }

        });
    };

    vm.preload();
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      vm.preload();
    });*/


  })

;

'use strict';
angular
  .module('frontendApp')
  .controller('AppController', function ($state, $log, $rootScope, $scope, $timeout, toastr,
                                         ContentService, $stateParams) {
    var vm = this;
    $log.debug('AppController');

    /*************** UI TEXT AND TRANSLATIONS **************/
    $rootScope.wct = {};
    $rootScope.scrollDir = '';
   /* $rootScope.$watch('scrollDir', function () {
      console.log('scrollDir', $rootScope.scrollDir)
    }, true);*/
    /*************** searchOn **************/
    $rootScope.searchOn = false;
    $rootScope.showSearch = function (value) {
      $rootScope.resultsOn = false;
      $rootScope.searchOn = (value) ? value : !$rootScope.searchOn;
    };
    /*************** APP MENU **************/
    $rootScope.menu = true;
    $rootScope.showMenu = function (value) {
      $rootScope.menu = (value) ? value : !$rootScope.menu;
    };

    $rootScope.setSection = function (section){
      if($rootScope.fullLoaded === true && $rootScope.fullLoaded){
        $rootScope.currentSec = angular.copy(section.id);
        $rootScope.$stateParams.section = $rootScope.fixNameUrl(section.name);
        $state.go($rootScope.currentState, $rootScope.$stateParams, {notify: false,reload:false,reloadOnSearch: false});
      }
    };

    /**** LOADER ****/
    $rootScope.$watch('showLoader', function () {
      if ($rootScope.showLoader === true) {
        document.body.style.overflow = 'hidden';
      }
      else {
        $timeout(function () {
          document.body.style.overflow = 'initial';
        }, 2500);
      }
    }, true);

    /********  MODALS AND WEB FORMS ********/
    $rootScope.ctaTab = 1;
    $rootScope.ctaNav = function (value) {
      switch (value){
        case'next':
          $rootScope.ctaTab++;
          break;
        case 'prev':
          $rootScope.ctaTab--;
          break;
      }
    }
    $rootScope.modals = {
      currentModal: ''
    };
    $rootScope.modalTab = 1;
    $rootScope.showModal = function (modal, value) {
      $log.log(modal);
      if(modal === 'modalmenu'){
        $rootScope.showMenu();
      }
      $rootScope.currentModal = modal;
      $rootScope.modals.currentModal = 'app/views/modals/' + modal + '.html';
      $rootScope.modalTab = 1;
      $rootScope.formData = {};
      $rootScope.searched = [];
      $rootScope.ctaTab = 1;
      $rootScope.validateRequest();
      $("html, body")
        .animate({scrollTop: 0 }, 1000);

    };
    $rootScope.formDataHome = {};
    $rootScope.closeModal = function () {
      $rootScope.modals.currentModal = '';
      $rootScope.modalTab = 1;
    };
    $rootScope.$watch('modals', function () {
      if($rootScope.showLoader===false){
        if ($rootScope.modals.currentModal != '') {
          document.body.style.overflow = 'hidden';
        }
        else {
          document.body.style.overflow = 'initial';
        }
      }
    }, true);
    $rootScope.navModals = function (value) {
      switch (value) {
        case 'prev':
          if ($rootScope.modalTab > 1) {
            $rootScope.modalTab--;
          }
          break;
        case 'next':
          $rootScope.modalTab++;
          $timeout(function () {
            if ($rootScope.currentModal != 'modalpresskit') {
              $rootScope.closeModal();
            }
          }, 5000);
          break;
        default:
          $rootScope.modalTab = value;
          break;
      }
    };
    $rootScope.$watch('modals', function () {
     // $log.log('actualiza modals', $rootScope.modals)
    }, true);
    //recaptcha
    function onloadCallback() {
      /*grecaptcha.ready(function () {
        grecaptcha.execute('6LfvLrgUAAAAAKwr9FHjRABHKfH6oLyQ6bzMldo0', {action: 'contact'})
          .then(function (token) {
            //$log.log('CAPTCHA', token);
            $rootScope.gc = token;
          });
      });*/
    }
    $rootScope.validateRequest = function () {
      onloadCallback();
    };
    $rootScope.sendForm = function (id, data, flash) {
      $log.log('ingresa', id, data);
      if (id && data) {
        $log.log('ingresa 0');

        var params = {
          mailingcategory_id: id,
          gc: $rootScope.gc,
          fields: data
        };
        $log.log('params', params);
        ContentService.sendform(params)
          .success(function (res) {
            $log.log('sendform res', res);
            if (res.status) {
              $rootScope.navModals('next');
              $log.log('sendform', res)
            }
            else {
              toastr.warning('Please try again', 'Connection error');
            }
          });
      }
      else {
        $log.log('ingresa 1');
        $rootScope.navModals('next');
      }
      if (flash) {
        toastr.success($rootScope.sT('Mensaje enviado', 'Message sent'), 'Success');
      }

    };



    /********** SEARCH FUNCTIONS ***********/
    $rootScope.searchContent = function (filters){
      $rootScope.searched = [];
     // filters.gc = $rootScope.gc;
      filters.lan = $rootScope.language;
      $rootScope.resultsOn = true;
      console.log('SEARCHED', filters);
      /*ContentService.websearch(filters)
        .success(function (res) {
          $log.log('SEARCH RESPONSE',res);
          $rootScope.searched = res.result;
        });*/
    };

    $rootScope.$watch('formData', function () {
      //$log.log('actualiza modals', $rootScope.modals);
      $rootScope.blockForm = false;
      if (!$rootScope.blockForm.search || $rootScope.blockForm.search === 'es' || $rootScope.blockForm.search === 'en') {
        $rootScope.blockForm = true;
      }
    }, true);


    /******** OTHER CONFIGURATIONS *********/

    $rootScope.defaultOwlConf = {
      items: 1,
      nav: false,
      // startPosition:parseInt(index),
      loop: true,
      autoplay: true,
      autoplaySpeed:10000,
      autoplayTimeout: 10000,
      //smartSpeed:7000,
      autoplayHoverPause: false,
      /*animateIn: 'flipInY',
      animateOut: 'flipOutY', */
      /*animateIn: 'fadeInLeft',
      animateOut: 'fadeOutRight',*/
      animateIn: 'fadeInRight',
      animateOut: 'fadeOutLeft',
    };
    $rootScope.copyToShare = function () {
      $log.log('copy');
      var copyText = document.getElementById("myInput");
      copyText.select();
      document.execCommand("copy");
      var a = copyText.value;
      var split = a.slice(0, 30);
      $log.log(a, split);
      toastr.success(split + '..', 'Enlace copiado');
    };
    $rootScope.momths = [
      {value: '1', label: {es: 'Enero', en: 'January'}},
      {value: '2', label: {es: 'Febrero', en: 'Febrary'}},
      {value: '3', label: {es: 'Marzo', en: 'March'}},
      {value: '4', label: {es: 'Abril', en: 'April'}},
      {value: '5', label: {es: 'Mayo', en: 'May'}},
      {value: '6', label: {es: 'Junio', en: 'June'}},
      {value: '7', label: {es: 'Julio', en: 'July'}},
      {value: '8', label: {es: 'Agosto', en: 'August'}},
      {value: '9', label: {es: 'Septiembre', en: 'September'}},
      {value: '10', label: {es: 'Octubre', en: 'October'}},
      {value: '11', label: {es: 'Noviembre', en: 'November'}},
      {value: '12', label: {es: 'Diciembre', en: 'December'}},
    ];
    $rootScope.years = [
      {value: '2019', label: {es: '2019', en: '2019'}},
      {value: '2020', label: {es: '2020', en: '2020'}},
      {value: '2021', label: {es: '2021', en: '2021'}},
    ];

    /********** Maps Settings *************/
    $rootScope.mapConf = {
      bolivia: {lat:-16.0920796,lon:-72.5869263},
      center: {lat:-16.0920796,lon:-63.588653},
      zoom: 10,
      currentCity: {}
    };
    $rootScope.getGPS = function (lat, lon) {
      var exit = [lat, lon];
      return exit;
    };
    $rootScope.openInMaps = function (lat, lon) {
      // If it's an iPhone..
      if (
        (navigator.platform.indexOf("iPhone") !== -1) ||
        (navigator.platform.indexOf("iPod") !== -1) ||
        (navigator.platform.indexOf("iPad") !== -1)
      )
        window.open("maps://maps.google.com/maps?daddr="+lat+","+lon+"&amp;ll=");
      else
        window.open("http://maps.google.com/maps?daddr="+lat+","+lon+"&amp;ll=");
    }

    /******** SECTIONS RENDER DATA *********/




  });

(function() {
  'use strict';

  angular
      .module('frontendApp')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1516719002839;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontendApp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, ContentService,
                    ImageLoader,
                    $anchorScroll, $location,
                    localStorageService, $timeout, $window, $stateParams) {

    //REST API ROUTE
    //$rootScope.api = 'http://localhost:8000';
    //$rootScope.api = 'http://192.168.0.10:8000';
    $rootScope.api = 'http://bid.aknatechnologies.com/restapi/public';
    //$rootScope.api = '';
    //SESSION VARS MANIPULATION
    $rootScope.getSessionParam = function (key) {
      return localStorageService.get(key);
    };
    //$log.log('MARK STATE PARAMS', $stateParams.lan);
    $rootScope.setSessionParam = function (key, val) {
      return localStorageService.set(key, val);
    };
    // SETTING SPANISH AS DEFAULT LANGUAGE
    $rootScope.lanList=['es', 'en', 'fr', 'pt'];

   /* if ($stateParams.lan == 'es' || $stateParams.lan == 'en') {
      $rootScope.language = $stateParams.lan;
    }
    else {
      $rootScope.language = 'es';
    }*/
    $rootScope.language = $stateParams.lan;
    //VERIFY CURRENT LANGUAGE
    $timeout(function () {
      /*if ($stateParams.lan == 'es' || $stateParams.lan == 'en') {
        $rootScope.changeLanguage($stateParams.lan, $rootScope.currentState);
      }
      else {
        $rootScope.language = 'es';
        //$state.go('home', {lan: 'es'}, {reload: true});
      }*/
      $rootScope.language = $stateParams.lan;
    }, 1000);
    //TRANSALATE
    $rootScope.transl = function (target) {
      if (target) {
        return target[$rootScope.language];
      }
      else {
        return '';
      }
    };
    $rootScope.sT = function (value1, value2) {
      if ($rootScope.language == 'es') {
        return value1;
      }
      else {
        return value2;
      }
    };
    //CHANGE OF ROUTE SETTING A NEW LANGUAGE
    $rootScope.changeLanguage = function (value, state) {
      $rootScope.language = value;
      $rootScope.setSessionParam('language', value);
      $state.go(state, {lan: value});
      delete $rootScope.wc;
    };
    //MAIL TO FUNCTION
    $rootScope.sendMail = function (emailId, subject, message) {
      $window.open("mailto:" + emailId + "?subject=" + subject + "&body=" + message, "_self");
    };
    $rootScope.encodeName = function (value) {
      return encodeURI(value);
    };
    $rootScope.stateGo = function (state, params, reload) {
      if(!params ){
        params = {};
      }
      if(!params.language){
        params.lan=$rootScope.language;
      }
      $state.go(state, params, reload);
      $rootScope.closeModal();
      //$rootScope.showLoader = true;
      // $rootScope.scroller(sec);
    };
    $rootScope.scrollerToTop = function () {
      $timeout(function () {
        $("html, body")
          .animate({scrollTop: 0}, 500);
      }, 100);
    };
    $rootScope.scroller = function (sec) {
      $timeout(function () {
        console.log('SCROLLER TO', sec);
        $("html, body")
          .animate({scrollTop: $('#' + sec).offset().top-60}, 1000);
      }, 100);
    };
    $rootScope.fixLanguage = function () {
      if ($stateParams.lan == 'es' || $stateParams.lan == 'en') {
        $rootScope.language = $stateParams.lan;
      }
      else {
        $rootScope.language = 'es';
        $state.go('home', {lan: 'es'});
      }
    };


    //$rootScope.wc = {};
    $rootScope.showLoader = false;
    //document.body.style.overflow = 'hidden';
    $rootScope.cf = {
      title:''
    };
    $rootScope.setCf = function (value) {
      $rootScope.cf = value;
    };
    //AUTO EXECUTE ON ROUTE CHANGE OR LOAD
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      console.log('$stateChangeSuccess', $stateParams);
      $state.current = toState;
      $rootScope.$state = $state;
      $rootScope.currentState = $state.current.name;
      $rootScope.context = $stateParams.context;
      $rootScope.$stateParams = $stateParams;
      $rootScope.currentURL = $window.location.href;
      //CLOSE OPEN MODALS
      $rootScope.closeModal();
      //AUTO SCROLL TO TOP PAGE
      $rootScope.scrollerToTop();
      //SCREEN WIDTH
      $rootScope.verifyScreenWidth();
      //GET RESTAPI CONTENTS
      $rootScope.loadContent();
    });

    $rootScope.loadContent = function (){
      ContentService.webcontent($rootScope.currentState, $stateParams)
        .success(function (res) {
          if (res.status) {
            $rootScope.wc = res.result;
            console.log('all', res);
            console.log('webcontent', $rootScope.wc);
            switch ($rootScope.currentState) {
              case 'home':
                var images = $rootScope.getImageArray($rootScope.wc.webhomecarousell, 'image' );
                $rootScope.preLoader(images);
                break;
              default:
                $rootScope.secPicked = $rootScope.wc.picked;
                $rootScope.currentSec=0;
                if($rootScope.$stateParams.section!=''){
                  angular.forEach($rootScope.wc.picked.websection, function (item) {
                    if(item.name ==  decodeURI($rootScope.$stateParams.section)){
                      $timeout(function () {
                        $rootScope.scroller('section-'+item.id);
                        $rootScope.currentSec = angular.copy(item.id);
                      }, 100);
                    }
                  });
                }
                $timeout(function () {
                  $rootScope.fullLoaded = true;
                }, 1100);
                $rootScope.getRelatedContent();
                $rootScope.showLoader = false;
                break;
            }
          }
        });
    };

    $rootScope.getRelatedContent = function(){
      var currentIndex = -1;
      $rootScope.relatedCol = [];
      angular.forEach($rootScope.wc.webroute.webcollection, function (i, k) {
        if(i.id == $rootScope.secPicked.id){
          currentIndex = k;
        }
      });
      if(currentIndex > 0){
        $rootScope.relatedCol.push($rootScope.wc.webroute.webcollection[currentIndex-1])
      }
      if(currentIndex + 1 < $rootScope.wc.webroute.webcollection.length){
        $rootScope.relatedCol.push($rootScope.wc.webroute.webcollection[currentIndex+1])
      }
      if(currentIndex + 2 < $rootScope.wc.webroute.webcollection.length){
        $rootScope.relatedCol.push($rootScope.wc.webroute.webcollection[currentIndex+2])
      }
    };

    $rootScope.verifyScreenWidth = function () {
      if($rootScope.currentState != 'home' &&  $(window).width() >= 1024){
        console.log('ANCHO DE PANTALLA', $(window).width());
        $rootScope.menu = true;
      }
      else{
        $rootScope.menu = false;
      }
    };

    $rootScope.getImageArray = function (source, target) {
      var imageArray = [];
      angular.forEach(source, function (value, key) {
        if (value[target]) {
          imageArray.push($rootScope.api + value[target]);
        }
      });
      return imageArray;
    };

    $rootScope.preLoader = function (imageArray) {
      ImageLoader.loadImages(imageArray).then(function (loadedStrings) {
        $rootScope.imageStringsList = loadedStrings;
        $log.log($rootScope.imageStringsList);
        $rootScope.showLoader = false;
      });
    };

    $rootScope.fixNameUrl = function (link) {
      return encodeURI(link);
    };

    $rootScope.renderTag = function (tags) {
      var t = tags.split(';');
      var exit = '';
      angular.forEach(t,function (i) {
        exit +=  i.replace(' ','')+' ';
      });
      return exit;
    };

    $rootScope.shuffle = function (obj1, obj2) {
      var exit = [];
      var index = obj2.length;
      var rnd = Math.floor(Math.random() * index);
      console.log('Random',rnd, index);
      angular.forEach(obj1, function (v, k) {
        exit.push(v);
        if (k == 2 || k == 1) {
          obj2[rnd].webcontext.title ={
            es:'Publicidad',
            en:'Advertising'
          };
          obj2[rnd].adv = true;
          exit.push(obj2[rnd]);
        }
      });
      $log.log('salida', exit)
      return exit;
    };

    $rootScope.openInNewTab = function(url) {
      var win = $window.open(url, '_blank');
      win.focus();
    };

    $rootScope.shortyear = function (year) {
      var exit = ''+year;
      return exit.slice(2,4);
    };

    $rootScope.magNumber=function (item) {
      var year = $rootScope.shortyear(item.year);
      var month = ((item.month<10)?'0':'')+item.month;
      var exit = month+'.'+year;
      return exit;
    };

    $rootScope.magNumberLoc=function (item) {
      var location = (item.location)?item.location+' / ':'';
      var year = (item.year)?item.year:'';
      var month = ((item.month<10)?'0':'')+item.month;
      var exit = location + month+'.'+year;
      return exit;
    };



  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/home');
    $stateProvider
      .state('home', {
        url: '/:lan',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/main.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('manual', {
        url: '/:lan/manual/:alias/:collection/:section',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/manual.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })


    $urlRouterProvider.otherwise('/es');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('frontendApp')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $locationProvider, $authProvider, localStorageServiceProvider) {
    /*// Set the default quality
    $colorThiefProvider.setDefaultQuality(50);

    // Set the default palette color count
    $colorThiefProvider.setDefaultColorCount(5);

    // Set wether to return arrays (ColorThief's default) or
    // objects like {r: 242, g: 124, b: 91} (false by default).
    $colorThiefProvider.setReturnObjects(true);*/

    // Login
    $authProvider.loginUrl = 'http://localhost:8000/api/authenticate';
    localStorageServiceProvider
      .setPrefix('adminApp')
      .setStorageType('sessionStorage')
      .setNotify(true, true);

    // Enable log
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode(true).hashPrefix('#');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
    new WOW().init();
  }

})();

angular.module("frontendApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/views/loader.html","<div class=\"loader-wrapper\"><p class=\"message\" data-ng-if=\"$root.showLoader\"><span class=\"loading\" aria-hidden=\"true\"></span></p><div class=\"load\" data-ng-if=\"$root.showLoader\"><div class=\"white-panel\"></div><svg class=\"brand\" width=\"135px\" height=\"50px\" viewbox=\"0 0 135 50\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Page 1</title><desc>Created with Sketch.</desc><defs><polygon id=\"path-1\" points=\"30.7987973 0.130773196 30.7987973 33.3615292 0.100945017 33.3615292 0.100945017 0.130773196 30.7987973 0.130773196\"></polygon><polygon id=\"path-3\" points=\"2.81757821e-05 0.14742268 54.1515164 0.14742268 54.1515164 49.8281261 2.81757821e-05 49.8281261\"></polygon></defs><g id=\"WEB\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Desktop-Landscape-Copy\" transform=\"translate(-572.000000, -15.000000)\"><g id=\"Page-1\" transform=\"translate(572.000000, 15.000000)\"><path d=\"M70.1984536,20.9126804 L70.1984536,15.1128522 L76.6888316,15.1128522 C78.5786942,15.1128522 80.8312715,15.5985911 80.8312715,17.9195533 L80.8312715,18.0118213 C80.8312715,19.9358763 79.2817869,20.9126804 76.2271478,20.9126804 L70.1984536,20.9126804 Z M78.1152921,33.8901718 L70.1984536,33.8901718 L70.1984536,27.8150859 L77.8843643,27.8150859 C81.0297251,27.8150859 82.6252577,28.8210997 82.6252577,30.8064948 L82.6252577,30.8989347 C82.6252577,32.8845017 81.1084192,33.8901718 78.1152921,33.8901718 L78.1152921,33.8901718 Z M85.2506873,23.6764261 C87.6946735,22.020756 88.8848797,19.7683505 88.8848797,16.8164605 L88.8848797,16.7240206 C88.8848797,14.3827835 88.1137457,12.4741924 86.5264605,10.8884536 C84.5632302,8.92487973 81.5274914,7.88707904 77.7475945,7.88707904 L62.2833333,7.88707904 L62.2848797,41.115945 L78.1152921,41.115945 C86.0989691,41.115945 90.6790378,37.7106186 90.6790378,31.7729897 L90.6790378,31.6820962 C90.6790378,27.8630241 88.9963918,25.3626804 85.2506873,23.6764261 L85.2506873,23.6764261 Z\" id=\"Fill-1\" fill=\"#3C3B3B\"></path><g id=\"Group-5\" transform=\"translate(104.123711, 7.756357)\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><g id=\"Clip-4\"></g><path d=\"M22.3775773,16.7443471 L22.3775773,16.8364433 C22.3775773,22.2874742 18.6782646,25.9508763 13.1727663,25.9508763 L8.2007732,25.9508763 L8.2007732,7.54108247 L13.1727663,7.54108247 C18.6782646,7.54108247 22.3775773,11.2388488 22.3775773,16.7443471 M13.1727663,0.130773196 L0.100945017,0.130773196 L0.10919244,33.3615292 L13.1727663,33.3596392 C18.146134,33.3596392 22.6578179,31.6565464 25.8803265,28.5642784 C29.0530069,25.5197766 30.7988832,21.321323 30.7988832,16.7443471 L30.7988832,16.6517354 C30.7988832,7.0792268 23.3847938,0.130773196 13.1727663,0.130773196\" id=\"Fill-3\" fill=\"#3C3B3B\" mask=\"url(#mask-2)\"></path></g><path d=\"M96.963299,7.8340378 C99.2000687,7.8340378 101.015017,9.6469244 101.015017,11.8836942 L101.015017,41.1226976 L92.9148454,41.1226976 L92.9148454,7.83300687 L96.963299,7.8340378 Z\" id=\"Fill-6\" fill=\"#3C3B3B\"></path><g id=\"Group-10\" transform=\"translate(0.000000, 0.024399)\"><mask id=\"mask-4\" fill=\"white\"><use xlink:href=\"#path-3\"></use></mask><g id=\"Clip-9\"></g><path d=\"M39.4686942,19.8889863 C38.3095876,19.8410481 38.1027148,20.5407045 39.8427491,20.9085739 C42.2999656,21.4274742 40.6272852,19.9376117 39.4686942,19.8889863 M35.8327835,17.1599485 C32.3492784,16.0319416 34.6415464,18.8195704 36.2994502,19.0042784 C37.9556357,19.187268 38.3011684,17.9596048 35.8327835,17.1599485 M25.5753952,14.637268 C24.5601031,15.1704296 26.3771134,17.5291924 31.0247079,17.6554811 C35.6740206,17.7840034 29.6810653,12.4814261 25.5753952,14.637268 M34.5080412,48.7802234 C35.9697251,46.0608076 39.152543,42.0951718 45.9570103,34.1008419 C56.1326117,22.1441409 25.9786598,26.1592612 20.8114777,17.1102921 C16.5554639,9.65445017 32.3939519,4.29568729 41.9642268,0.147405498 C48.1858763,4.24792096 52.7003093,10.8798797 53.8625086,18.8336598 C55.8521993,32.4224914 47.370756,45.1226632 34.5080412,48.7802234 M28.4554639,29.5078866 C24.1855326,36.4218041 37.9027148,36.5259278 31.5561512,49.445 C31.3700687,49.475756 31.1855326,49.5118385 30.9956701,49.5389863 C16.2018557,51.7049656 2.45408935,41.4678522 0.288109966,26.6740378 C-0.737491409,19.6587457 1.02831615,12.8800515 4.74103093,7.45977663 C4.05030928,23.0707732 32.4432646,23.0534192 28.4554639,29.5078866\" id=\"Fill-8\" fill=\"#3C3B3B\" mask=\"url(#mask-4)\"></path></g></g></g></g></svg></div></div>");
$templateCache.put("app/main/main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/views/modals/modalcontact.html","<div class=\"form-cta wow slideInUp\" data-wow-delay=\"1s\" data-ng-class=\"{\'open\':$root.ctaOn}\" data-ng-init=\"$root.ctaOn = false\"><div class=\"cta-header\"><a class=\"cta-title\" data-ng-click=\"$root.ctaOn = !$root.ctaOn; $root.ctaTab = 1\">{{$root.transl($root.uiText.contact.title)}}</a> <a data-ng-click=\"$root.ctaNav(\'prev\')\" data-ng-if=\"$root.ctaOn && $root.ctaTab > 1 && $root.ctaTab < 4\" class=\"cta-prev\"><i class=\"fas fa-chevron-left\"></i></a> <a data-ng-click=\"$root.ctaOn = !$root.ctaOn\" data-ng-if=\"($root.ctaOn && $root.ctaTab == 1) || ($root.ctaOn && $root.ctaTab == 4)\" class=\"cta-prev\"><i class=\"fas fa-times\"></i></a> <a data-ng-hide=\"!$root.ctaOn\" class=\"cta-step\">{{$root.ctaTab}}/4</a></div><form class=\"cta-form input-group\" data-ng-if=\"$root.ctaOn && $root.ctaTab ==1\"><input type=\"text\" class=\"form-control\" data-ng-model=\"$root.formData.name\" id=\"exampleInputAmount\" placeholder=\"{{$root.transl($root.uiText.contact.placeholder1)}}\"><div class=\"input-group-addon\" data-ng-click=\"$root.ctaNav(\'next\')\"><i class=\"fas fa-chevron-right\"></i></div></form><form class=\"cta-form input-group\" data-ng-if=\"$root.ctaOn && $root.ctaTab ==2\"><input type=\"email\" class=\"form-control\" data-ng-model=\"$root.formData.email\" id=\"exampleInputAmount\" placeholder=\"{{$root.transl($root.uiText.contact.placeholder2)}}\"><div class=\"input-group-addon\" data-ng-click=\"$root.ctaNav(\'next\')\"><i class=\"fas fa-chevron-right\"></i></div></form><form class=\"cta-form input-group\" data-ng-if=\"$root.ctaOn && $root.ctaTab ==3\"><textarea name=\"\" class=\"form-control\" data-ng-model=\"$root.formData.message\" id=\"exampleInputAmount\" placeholder=\"{{$root.transl($root.uiText.contact.placeholder3)}}\"></textarea><div class=\"input-group-addon\" data-ng-click=\"$root.ctaNav(\'next\');$root.sendForm(3, $root.formData, true)\"><i class=\"fas fa-chevron-right\"></i></div></form><form class=\"cta-form\" data-ng-if=\"$root.ctaOn && $root.ctaTab ==4\"><p class=\"cta-message\">{{$root.transl($root.uiText.contact.messageSuccess)}}</p></form></div>");
$templateCache.put("app/views/modals/modalmenu.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><a class=\"close-button wow fadeIn\" data-ng-if=\"$root.modals.currentModal!=\'\'\" data-ng-click=\"$root.closeModal()\"><svg width=\"50px\" height=\"50px\" viewbox=\"0 0 50 50\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"close\" fill=\"#FFFFFF\"><path d=\"M22.263456,25.0918831 L6,41.3553391 L8.82842712,44.1837662 L25.0918831,27.9203102 L41.3553391,44.1837662 L44.1837662,41.3553391 L27.9203102,25.0918831 L44.1837662,8.82842712 L41.3553391,6 L25.0918831,22.263456 L8.82842712,6 L6,8.82842712 L22.263456,25.0918831 Z\" id=\"Combined-Shape\"></path></g></g></svg></a><div class=\"menu-wrapper\" customheight=\"\"><h3 class=\"form-title {{$root.gustuTheme}}\">Menú</h3><div class=\"btn-group btn-group-lan mobile {{$root.language}}\" dropdown=\"\" is-open=\"$root.isopen2\"><button id=\"single-button\" type=\"button\" class=\"btn btn-primary\" dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul class=\"dropdown-menu\" dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" data-ng-repeat=\"a in $root.wc.webconfig\" data-ng-if=\"a.config != $root.language && a.value == \'1\'\"><a href=\"#\" class=\"{{a.config}}\" data-ng-click=\"$root.changeLanguage(a.config,$root.currentState)\"></a></li></ul></div><ul class=\"social-link mobile\"><li data-ng-if=\"$root.wc.websocial[0].url!=\'\'\"><a target=\"_blank\" href=\"https://api.whatsapp.com/send?phone=591{{$root.wc.websocial[0].url}}\" class=\"social-icon\"><i class=\"fab fa-whatsapp\"></i></a></li><li data-ng-if=\"$root.wc.websocial[1].url!=\'\'\"><a href=\"{{$root.wc.websocial[1].url}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-facebook-f\"></i></a></li><li data-ng-if=\"$root.wc.websocial[2].url!=\'\'\"><a href=\"{{$root.wc.websocial[2].url}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-twitter\"></i></a></li><li data-ng-if=\"$root.wc.websocial[3].url!=\'\'\"><a href=\"{{$root.wc.websocial[3].url}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-linkedin-in\"></i></a></li></ul><div class=\"menu-w\"><div class=\"menu-box left\"><div class=\"menu-image-box wow fadeIn\"><div class=\"image-background\"><div class=\"image\" data-ng-style=\"{\'background\': \'url(\' + $root.api + $root.menuBack + \')\'}\"></div></div></div></div><div class=\"menu-box right\"><div class=\"menu-sep wow fadeIn\"></div><ul class=\"menu-options\"><li class=\"wow fadeIn\" data-wow-delay=\"{{0+(($index+1)*0.2)}}s\" data-ng-repeat=\"state in $root.wc.webroute\" data-ng-if=\"state.type==1\"><a data-ng-click=\"$root.stateGo(state.state)\" data-ng-mouseover=\"$root.menuImage(state)\" data-ng-class=\"{\'active\':$root.currentState==state.state}\">{{$root.transl(state.url)}}</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/views/modals/modalsearch.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><a class=\"close-button\" data-ng-click=\"$root.closeModal()\"><svg width=\"50px\" height=\"50px\" viewbox=\"0 0 50 50\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"close\" fill=\"#FFFFFF\"><path d=\"M22.263456,25.0918831 L6,41.3553391 L8.82842712,44.1837662 L25.0918831,27.9203102 L41.3553391,44.1837662 L44.1837662,41.3553391 L27.9203102,25.0918831 L44.1837662,8.82842712 L41.3553391,6 L25.0918831,22.263456 L8.82842712,6 L6,8.82842712 L22.263456,25.0918831 Z\" id=\"Combined-Shape\"></path></g></g></svg></a><div class=\"form-wrapper large\"><form ng-submit=\"$root.searchContent($root.formData)\"><h3 class=\"form-title\">{{$root.sT(\'Buscar\',\'Search\')}}</h3><div class=\"input-row\"><div class=\"btn-group btn-group-search\"><input type=\"text\" data-ng-model=\"$root.formData.search\" placeholder=\"{{$root.sT(\'Buscar por\',\'Search for\')}}\" class=\"form-control\"> <button type=\"button\" class=\"btn btn-primary\"><i class=\"fas fa-search\"></i></button></div></div><div class=\"input-row\"><button style=\"margin-top: 20px; margin: 20px auto; display: block; float: none;\" type=\"submit\" class=\"button button--antiman button--round-l button--text-medium\">{{$root.sT(\'Buscar\',\'Search\')}}</button></div></form><div class=\"area-wrapper fullpage\" style=\"padding-top: 0\"><div class=\"area-box\" style=\"transform: scale(0.9)\" data-ng-repeat=\"area in $root.searched\"><div class=\"area\" data-ng-click=\"$root.stateGo($root.childRoute(area), {lan: $root.language, id:area.id})\"><div class=\"image-background\"><div class=\"image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+((area.image)?area.image:area.image2)+ \')\'}\"></div></div><div class=\"legend\" style=\"bottom: 25px;\"><p class=\"area-legend\">{{$root.transl(area.title)}}</p></div></div></div></div></div></div></div>");
$templateCache.put("app/views/components/article.html","<div class=\"article\" id=\"section-{{section.id}}\" data-ng-repeat=\"section in $root.wc.picked.websection\"><div class=\"watcher\" data-in-view=\"($inview)?$root.setSection(section):\'\'\"></div><h2 data-ng-if=\"section.title.es!=\'\'\">{{section.title.es}}</h2><div class=\"content\" data-ng-repeat=\"subitem in section.websectiondata | orderBy:\'order\'\"><div class=\"content-box\" data-ng-if=\"subitem.type==0\" data-ng-bind-html=\"$root.transl(subitem.content)\"></div><div class=\"content-box\" data-ng-if=\"subitem.type==1\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"{{subitem.name}}\"></div><div class=\"content-box video\" data-ng-if=\"subitem.type==2\" style=\"margin-bottom: 20px\"><div class=\"video\" my-youtube=\"\" code=\"subitem.link\"></div></div><div class=\"content-box slider\" data-ng-if=\"subitem.type==3\"><ng-owl-carousel class=\"owl-theme gallery-wrapper\" owl-items=\"subitem.websectiondataitem\" owl-properties=\"$root.defaultOwlConf\" owl-ready=\"$root.ready($api)\"><div class=\"gallery-item\" data-ng-repeat=\"item in subitem.websectiondataitem\"><img ng-src=\"{{ $root.api+item.image }}\" alt=\"{{item.name}}\"></div></ng-owl-carousel></div><div class=\"content-box accordion\" data-ng-if=\"subitem.type==4\"><accordion close-others=\"oneAtATime\"><div accordion-group=\"\" data-ng-repeat=\"subitem2 in subitem.websectiondataitem\" class=\"panel-default panel-bid\" is-open=\"faq.status[$index].open\"><accordion-heading><img ng-src=\"{{$root.api+subitem2.image}}\" alt=\"\"> {{$root.transl(subitem2.title)}} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': faq.status[$index].open, \'glyphicon-chevron-right\': !faq.status[$index].open}\"></i></accordion-heading><p data-ng-bind-html=\"$root.transl(subitem2.content)\"></p></div></accordion></div><div class=\"content\" data-ng-if=\"subitem.type==5\"><a class=\"content-box btn-cta\" target=\"_blank\" href=\"{{subitem.link}}\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\" data-ng-bind-html=\"subitem.title\"></h3><div class=\"content-box-icon-2\"><i class=\"fas fa-arrow-down\"></i></div></a></div><div class=\"content\" data-ng-if=\"subitem.type==6\"><div class=\"content-box list-cta\"><div class=\"list-cta-item\" data-ng-repeat=\"item in subitem.websectiondataitem\"><div class=\"content-box-icon\"><p>{{$index+1}}</p></div><h3 class=\"content-box-title\">{{item.title.es}}</h3><a class=\"content-box-icon-2\" href=\"{{item.link}}\" target=\"_blank\"><i class=\"fas fa-arrow-down\"></i></a></div></div></div><div class=\"content\" data-ng-if=\"subitem.type==7\"><div class=\"content-box informative type-1\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div></div><div class=\"content\" data-ng-if=\"subitem.type==8\"><div class=\"content-box informative type-2\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div></div><div class=\"content\" data-ng-if=\"subitem.type==9\"><div class=\"content-box informative type-3\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div></div><div class=\"content\" data-ng-if=\"subitem.type==10\"><div class=\"content-box informative type-4\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div></div><div class=\"content\" data-ng-if=\"subitem.type==11\"><div class=\"content-box informative type-5\"><div class=\"content-box-header\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3></div><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div></div><div class=\"content\" data-ng-if=\"subitem.type==12\"><div class=\"content-box filled color-primary type-1\"><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div><div class=\"btn-small secondary\" data-ng-if=\"subitem.link!=\'\'\">Boton de descarga</div></div></div><div class=\"content\" data-ng-if=\"subitem.type==13\"><div class=\"content-box filled color-primary type-2\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div></div><div class=\"content\" data-ng-if=\"subitem.type==14\"><div class=\"content-box filled color-secondary type-1\"><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div><div class=\"btn-small primary\" data-ng-if=\"subitem.link!=\'\'\">Boton de descarga</div></div></div><div class=\"content\" data-ng-if=\"subitem.type==15\"><div class=\"content-box filled color-secondary type-2\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div></div><div class=\"content\" data-ng-if=\"subitem.type==16\"><div class=\"content-box fill-mixed\"><div class=\"inner-box top\"><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div><div class=\"inner-box bottom\"><h3 class=\"content-box-title\">{{subitem.title2}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.link\"></div></div></div></div></div></div>");
$templateCache.put("app/views/components/breadcrumb.html","<div class=\"breadcrumb\" data-ng-class=\"{fixedtop:$root.scrollDir == \'down\',reduced:$root.menu}\"><p data-ng-if=\"$root.wc.picked.id == item.id\" data-ng-repeat=\"item in $root.wc.webroute.webcollection\"><span class=\"parent\">{{item.title}}</span> <span class=\"spliter\" data-ng-if=\"item.websection.length>1\"><i class=\"fas fa-chevron-right\"></i></span> <span class=\"child\" data-ng-if=\"sub.id==$root.currentSec\" data-ng-repeat=\"sub in item.websection\">{{sub.title.es}}</span></p></div>");
$templateCache.put("app/views/components/header.html","<div class=\"header\"><div class=\"menu-header\" data-ng-class=\"{reduced:$root.menu}\"><div class=\"navbar navbar-default\" role=\"navigation\"><ul class=\"nav navbar-nav lan-link\"><li><a href=\"\" class=\"btn-search\" data-ng-click=\"$root.showSearch()\"><svg width=\"30px\" height=\"30px\" viewbox=\"0 0 30 30\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Serch\" fill-rule=\"nonzero\" fill=\"#000000\"><path d=\"M12.5,22 C17.7467051,22 22,17.7467051 22,12.5 C22,7.25329488 17.7467051,3 12.5,3 C7.25329488,3 3,7.25329488 3,12.5 C3,17.7467051 7.25329488,22 12.5,22 Z M12.5,25 C5.59644063,25 0,19.4035594 0,12.5 C0,5.59644063 5.59644063,0 12.5,0 C19.4035594,0 25,5.59644063 25,12.5 C25,19.4035594 19.4035594,25 12.5,25 Z\" id=\"Oval\"></path><polygon id=\"Line\" points=\"18.3786797 20.5 27.5710678 29.6923882 29.6923882 27.5710678 20.5 18.3786797\"></polygon></g></g></svg></a></li></ul><svg class=\"brand\" width=\"135px\" height=\"50px\" viewbox=\"0 0 135 50\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Page 1</title><desc>Created with Sketch.</desc><defs><polygon id=\"path-1\" points=\"30.7987973 0.130773196 30.7987973 33.3615292 0.100945017 33.3615292 0.100945017 0.130773196 30.7987973 0.130773196\"></polygon><polygon id=\"path-3\" points=\"2.81757821e-05 0.14742268 54.1515164 0.14742268 54.1515164 49.8281261 2.81757821e-05 49.8281261\"></polygon></defs><g id=\"WEB\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Desktop-Landscape-Copy\" transform=\"translate(-572.000000, -15.000000)\"><g id=\"Page-1\" transform=\"translate(572.000000, 15.000000)\"><path d=\"M70.1984536,20.9126804 L70.1984536,15.1128522 L76.6888316,15.1128522 C78.5786942,15.1128522 80.8312715,15.5985911 80.8312715,17.9195533 L80.8312715,18.0118213 C80.8312715,19.9358763 79.2817869,20.9126804 76.2271478,20.9126804 L70.1984536,20.9126804 Z M78.1152921,33.8901718 L70.1984536,33.8901718 L70.1984536,27.8150859 L77.8843643,27.8150859 C81.0297251,27.8150859 82.6252577,28.8210997 82.6252577,30.8064948 L82.6252577,30.8989347 C82.6252577,32.8845017 81.1084192,33.8901718 78.1152921,33.8901718 L78.1152921,33.8901718 Z M85.2506873,23.6764261 C87.6946735,22.020756 88.8848797,19.7683505 88.8848797,16.8164605 L88.8848797,16.7240206 C88.8848797,14.3827835 88.1137457,12.4741924 86.5264605,10.8884536 C84.5632302,8.92487973 81.5274914,7.88707904 77.7475945,7.88707904 L62.2833333,7.88707904 L62.2848797,41.115945 L78.1152921,41.115945 C86.0989691,41.115945 90.6790378,37.7106186 90.6790378,31.7729897 L90.6790378,31.6820962 C90.6790378,27.8630241 88.9963918,25.3626804 85.2506873,23.6764261 L85.2506873,23.6764261 Z\" id=\"Fill-1\" fill=\"#3C3B3B\"></path><g id=\"Group-5\" transform=\"translate(104.123711, 7.756357)\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><g id=\"Clip-4\"></g><path d=\"M22.3775773,16.7443471 L22.3775773,16.8364433 C22.3775773,22.2874742 18.6782646,25.9508763 13.1727663,25.9508763 L8.2007732,25.9508763 L8.2007732,7.54108247 L13.1727663,7.54108247 C18.6782646,7.54108247 22.3775773,11.2388488 22.3775773,16.7443471 M13.1727663,0.130773196 L0.100945017,0.130773196 L0.10919244,33.3615292 L13.1727663,33.3596392 C18.146134,33.3596392 22.6578179,31.6565464 25.8803265,28.5642784 C29.0530069,25.5197766 30.7988832,21.321323 30.7988832,16.7443471 L30.7988832,16.6517354 C30.7988832,7.0792268 23.3847938,0.130773196 13.1727663,0.130773196\" id=\"Fill-3\" fill=\"#3C3B3B\" mask=\"url(#mask-2)\"></path></g><path d=\"M96.963299,7.8340378 C99.2000687,7.8340378 101.015017,9.6469244 101.015017,11.8836942 L101.015017,41.1226976 L92.9148454,41.1226976 L92.9148454,7.83300687 L96.963299,7.8340378 Z\" id=\"Fill-6\" fill=\"#3C3B3B\"></path><g id=\"Group-10\" transform=\"translate(0.000000, 0.024399)\"><mask id=\"mask-4\" fill=\"white\"><use xlink:href=\"#path-3\"></use></mask><g id=\"Clip-9\"></g><path d=\"M39.4686942,19.8889863 C38.3095876,19.8410481 38.1027148,20.5407045 39.8427491,20.9085739 C42.2999656,21.4274742 40.6272852,19.9376117 39.4686942,19.8889863 M35.8327835,17.1599485 C32.3492784,16.0319416 34.6415464,18.8195704 36.2994502,19.0042784 C37.9556357,19.187268 38.3011684,17.9596048 35.8327835,17.1599485 M25.5753952,14.637268 C24.5601031,15.1704296 26.3771134,17.5291924 31.0247079,17.6554811 C35.6740206,17.7840034 29.6810653,12.4814261 25.5753952,14.637268 M34.5080412,48.7802234 C35.9697251,46.0608076 39.152543,42.0951718 45.9570103,34.1008419 C56.1326117,22.1441409 25.9786598,26.1592612 20.8114777,17.1102921 C16.5554639,9.65445017 32.3939519,4.29568729 41.9642268,0.147405498 C48.1858763,4.24792096 52.7003093,10.8798797 53.8625086,18.8336598 C55.8521993,32.4224914 47.370756,45.1226632 34.5080412,48.7802234 M28.4554639,29.5078866 C24.1855326,36.4218041 37.9027148,36.5259278 31.5561512,49.445 C31.3700687,49.475756 31.1855326,49.5118385 30.9956701,49.5389863 C16.2018557,51.7049656 2.45408935,41.4678522 0.288109966,26.6740378 C-0.737491409,19.6587457 1.02831615,12.8800515 4.74103093,7.45977663 C4.05030928,23.0707732 32.4432646,23.0534192 28.4554639,29.5078866\" id=\"Fill-8\" fill=\"#3C3B3B\" mask=\"url(#mask-4)\"></path></g></g></g></g></svg></div></div><div><form class=\"search-input\" data-ng-class=\"{fixedtop:$root.scrollDir == \'down\',reduced:$root.menu}\" data-ng-if=\"$root.searchOn==true\" data-ng-submit=\"$root.searchContent($root.formData)\"><input type=\"text\" data-ng-model=\"$root.formData.search\" placeholder=\"{{$root.sT(\'Buscar por\',\'Search for\')}}\" class=\"form-control\"> <a href=\"\" data-ng-click=\"$root.showSearch()\" class=\"btn-close\"><i class=\"fas fa-times\"></i></a></form><div class=\"search-results\" data-ng-if=\"$root.resultsOn==true\" customheight=\"\" minus=\"80\"><div class=\"col-xs-12\"><p><strong>Example</strong></p><p>Lorem</p><hr></div><div class=\"col-xs-12\"><p><strong>Example</strong></p><p>Lorem</p><hr></div></div></div><ng-include data-src=\"\'app/views/components/menu.html\'\"></ng-include></div>");
$templateCache.put("app/views/components/menu.html","<div style=\"position: relative;\"><div class=\"menu\" data-ng-class=\"{open:$root.menu}\" data-ng-if=\"$root.currentState != \'home\'\"><ul class=\"menu-box\" customheight=\"\" minus=\"160\" autoscroll=\"true\"><h4 class=\"menu-title\">{{$root.wc.webroute.name}}</h4><li class=\"menu-item\" data-ng-repeat=\"item in $root.wc.webroute.webcollection\"><a href=\"\" data-ng-class=\"{active: item.websection.length==1 && $root.$stateParams.collection == item.name}\" data-ng-click=\"$root.stateGo(\'manual\', {lan:\'es\', alias: $root.$stateParams.alias, collection:item.name, section: \'\'}, true)\">{{item.title}}</a><ul class=\"menu-box second-level\" data-ng-if=\"item.websection.length > 1 && $root.wc.picked.id == item.id\"><li class=\"menu-item\" data-ng-repeat=\"sub in item.websection\"><a href=\"\" data-ng-click=\"$root.scroller(\'section-\'+sub.id)\" data-ng-class=\"{active: sub.id==$root.currentSec}\">{{sub.title.es}}</a></li></ul></li></ul><a href=\"\" class=\"btn-go-home\" data-ng-click=\"$root.stateGo(\'home\', {lan:\'es\'}, false)\"><i class=\"fas fa-chevron-left\"></i> Salir del manual</a></div><div class=\"menu-dismiss\" data-ng-click=\"$root.showMenu();\" data-ng-class=\"{open:$root.menu}\" data-ng-if=\"$root.currentState != \'home\'\"></div><a class=\"btn-burger\" data-ng-class=\"{open:$root.menu}\" data-ng-if=\"$root.currentState != \'home\'\" data-ng-click=\"$root.showMenu();\"><svg width=\"50px\" height=\"28px\" viewbox=\"0 0 50 28\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"menu\" fill=\"#000\"><rect id=\"Rectangle-3\" x=\"30\" y=\"0\" width=\"20\" height=\"4\"></rect><rect id=\"Rectangle-3-Copy-2\" x=\"20\" y=\"24\" width=\"30\" height=\"4\"></rect><rect id=\"Rectangle-3-Copy\" x=\"0\" y=\"12\" width=\"50\" height=\"4\"></rect></g></g></svg></a></div>");
$templateCache.put("app/views/components/upnext.html","<div class=\"article\"><h2>Podría interesarle</h2><div data-ng-click=\"$root.stateGo(\'manual\', {lan:\'es\', alias: $root.$stateParams.alias, collection:rel.name, section: \'\'})\" class=\"up-next\" data-ng-repeat=\"rel in $root.relatedCol\"><h5 class=\"up-next-title\" equalheight=\"\" targetclass=\"up-next-title\">{{rel.title}}</h5><div class=\"btn-small primary\">Ir al tema <i class=\"fas fa-chevron-right\"></i></div></div></div>");
$templateCache.put("app/views/pages/main.html","<div class=\"row\" customheight=\"\" data-ng-if=\"$root.wc\"><ng-include data-src=\"\'app/views/components/header.html\'\"></ng-include><div class=\"home-wrapper\" customheight=\"\"><h4>Manuales en:</h4><div class=\"btn-group btn-group-main\" dropdown=\"\" is-open=\"$root.isopen\"><button id=\"single-button\" type=\"button\" class=\"btn btn-main\" dropdown-toggle=\"\">Categorías <i class=\"fas fa-chevron-down\"></i></button><ul class=\"dropdown-menu {{$root.gustuTheme}}\" dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\"><a href=\"#\" data-ng-click=\"\">Categoría 1</a></li></ul></div><div class=\"home-item\" data-ng-repeat=\"route in $root.wc.webroute\" data-ng-click=\"$root.stateGo(\'manual\', {lan:$root.language, alias: $root.fixNameUrl(route.state), collection:$root.fixNameUrl(route.webcollection[0].name), section: \'#\'})\"><img ng-src=\"{{$root.api+route.image}}\" alt=\"{{route.state}}\" class=\"home-image\"><div class=\"home-legend\"><p>{{route.name}}</p></div></div></div></div>");
$templateCache.put("app/views/pages/manual.html","<div class=\"row\" customheight=\"\"><ng-include data-src=\"\'app/views/components/header.html\'\"></ng-include><div class=\"manual-wrapper\" scrolldetect=\"\"><div class=\"wrapper-body\"><ng-include data-src=\"\'app/views/components/breadcrumb.html\'\"></ng-include><h1>{{$root.wc.picked.title}}</h1><ng-include data-src=\"\'app/views/components/article.html\'\"></ng-include><ng-include data-src=\"\'app/views/components/upnext.html\'\"></ng-include></div></div></div>");
$templateCache.put("app/scripts/directives/wleft/wleft.html","<div class=\"left-box {{sec.class}}\"><div class=\"image-box\" data-ng-if=\"$root.secPicked\"><img data-ng-src=\"{{$root.api+$root.secPicked.image2}}\" alt=\"\"></div></div>");
$templateCache.put("app/scripts/directives/wright/wright.html","<div windowheight2=\"\" class=\"right-box {{sec.class}}\" data-ng-if=\"$root.secPicked\"><div class=\"article\"><div class=\"content\"><h1 class=\"sec-title\">{{$root.transl($root.secPicked.title) }}</h1><p class=\"sec-tags\">{{$root.transl($root.secPicked.tag)}}</p><p class=\"sec-tags\" data-ng-if=\"$root.secPicked.published_at != \'0000-00-00\'\">{{$root.secPicked.published_at}}</p><p class=\"sec-legend\">{{$root.transl($root.secPicked.webcontext.title)}}</p></div></div><div class=\"article\" data-ng-repeat=\"sub in $root.secPicked.websectiondata\"><div class=\"content\" data-ng-if=\"sub.type==0\"><div data-ng-bind-html=\"$root.transl(sub.content)\"></div></div><div class=\"row\" data-ng-if=\"sub.type==1\"><div class=\"col-xs-12\"><img style=\"display: block;max-width: 100%;margin: auto\" ng-src=\"{{ $root.api+sub.image }}\" alt=\"\"></div></div><div class=\"video\" data-ng-if=\"sub.type==2\" style=\"margin-bottom: 20px\"><div class=\"video\" my-youtube=\"\" code=\"sub.link\"></div></div><div class=\"slider\" data-ng-if=\"sub.type==3\"><ng-owl-carousel class=\"owl-theme gallery-wrapper\" owl-items=\"sub.websectiondataitem\" owl-properties=\"$root.defaultOwlConf\" owl-ready=\"$root.ready($api)\"><div class=\"gallery-item\" data-ng-repeat=\"item in sub.websectiondataitem\"><img ng-src=\"{{ $root.api+item.image }}\" alt=\"\"></div></ng-owl-carousel></div><div class=\"row\" data-ng-if=\"sub.type==4\"><div class=\"col-xs-12\" style=\"margin-bottom: 60px\"><accordion close-others=\"false\"><div accordion-group=\"\" data-ng-repeat=\"subitem2 in sub.websectiondataitem\" class=\"panel-default panel-profile\" is-open=\"faq.status[$index].open\"><accordion-heading>{{$root.transl(subitem2.title)}} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': faq.status[$index].open, \'glyphicon-chevron-right\': !faq.status[$index].open}\"></i></accordion-heading><p data-ng-bind-html=\"$root.transl(subitem2.content)\"></p></div></accordion></div></div></div></div>");}]);